// Base
import Image from 'next/image'
import { useState } from 'react'
import { useRouter } from 'next/router'

// Packages
import { setCookie } from 'nookies'

// Helpers
import { gtag, fbpixel } from '@helpers/trackers'

// Components
import { Column, Container, Row } from '@components/app/Layout'
import Box from '@components/helpers/box/Box'
import Text from '@components/helpers/text/Text'
import { Button } from '@components/common/button/Buttons'
import Selection from '@components/selectionBox/Selection'

// Styles
import styles from './LocationWrapper.module.sass'

// Images
import Hero from 'public/images/photos/airport-hero.png'

// Icons
import { MdAirplanemodeActive } from 'react-icons/md'

export interface SelectedData {
  id: number
  name: string
}

const LocationWrapper = () => {
  const [selected, setSelected] = useState({ airport: '', id: 0 })

  const router = useRouter()

  const saveHomeAirport = async () => {
    setCookie(null, 'airport', selected.id.toString(), {
      maxAge: 365 * 24 * 60 * 60,
      path: '/'
    })

    gtag.trackEvent('Select Home Airpot', selected.airport)
    fbpixel.trackEvent('Search')

    router.push('/deals')
  }

  return (
    <section className={styles.location}>
      <Image
        src={Hero}
        fill
        placeholder="blur"
        sizes="
          (min-width: 1120px) 1120px,
          375px
        "
        alt="Airport"
      />
      <Container>
        <Row position="center">
          <Column column={6} gutter={5}>
            <Box
              backgroundColor="white"
              borderRadius={{ sm: [8], lg: [24] }}
              padding={{ sm: [32, 24], lg: [64, 96] }}
              shadow="sm"
            >
              <Text
                tagName="h1"
                variant="title-4"
                spacing={{ sm: 8 }}
                align="center"
              >
                Select Your home airport
              </Text>
              <Text
                tagName="p"
                variant="body-1"
                color="grey"
                spacing={{ sm: 32, lg: 48 }}
                align="center"
              >
                You can add more airports later
              </Text>

              <Selection
                endpoint="/api/airports/c/search"
                placeholder="Example: New York or JFK"
                inputIcon={<MdAirplanemodeActive size={20} color="#6D7A80" />}
                listIcon={<MdAirplanemodeActive size={20} color="#6D7A80" />}
                setSelected={setSelected}
              />

              <Button
                variant="button-3"
                disabled={!selected.id}
                onClick={saveHomeAirport}
              >
                Continue
              </Button>
            </Box>
          </Column>
        </Row>
      </Container>
    </section>
  )
}

export default LocationWrapper
